<div id="breadcrumb-navigation" class="breadcrumb">
  {{ labels.administration }}
  <a
    id="dependencies-breadcrumb-link"
    class="breadcrumb-link selected"
    [routerLink]="['/wapi/admin/dependencies']"
  >
    &nbsp;>&nbsp;{{ labels.dependencies }}
  </a>
</div>

<br /><br />

<div id="dependencies-main-container" class="container">
  <mat-card id="dependencies-card">
    <div id="dependencies-header" class="header-options">
      <div id="dependencies-title" class="title">
        <div class="title-wrapper">
          <h1 class="main-title">{{ labels.dependencies }}</h1>
        </div>
      </div>
      <div class="header-actions">
        <button
          mat-raised-button
          class="filter-button"
          (click)="toggleSearch()"
          matTooltip="Filtro"
        >
          <mat-icon>filter_list</mat-icon>
          FILTRO
        </button>
        <button
          mat-raised-button
          color="primary"
          class="create-button"
          (click)="openModal()"
          matTooltip="{{ labels.tooltipCreate }}"
        >
          <mat-icon>add</mat-icon>
          {{ labels.createDependency }}
        </button>
      </div>
    </div>

    <!-- Search Panel -->
    @if (showSearchPanel) {
      <div class="search-panel">
        <div class="filters-grid">
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Buscar dependencias</mat-label>
            <input
              matInput
              [(ngModel)]="searchQuery"
              (input)="searchDependencies($any($event.target).value)"
              placeholder="Buscar por nombre o código..."
            />
            <mat-icon matSuffix>search</mat-icon>
          </mat-form-field>

          <!-- Column filters (removed Detalle to avoid redundancy) -->
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Código</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.code"
              (input)="onColumnFilterChange('code', $any($event.target).value)"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Estado (activo/inactivo)</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.status"
              (input)="onColumnFilterChange('status', $any($event.target).value)"
            />
          </mat-form-field>
          <mat-form-field appearance="outline" class="search-field">
            <mat-label>Dependencia Padre</mat-label>
            <input
              matInput
              [(ngModel)]="columnFilters.parent"
              (input)="onColumnFilterChange('parent', $any($event.target).value)"
            />
          </mat-form-field>
        </div>
        <button
          mat-stroked-button
          color="primary"
          (click)="resetFilters()"
          style="height: 40px; align-self: center"
        >
          <mat-icon style="margin-right: 6px">filter_alt_off</mat-icon>
          Limpiar filtros
        </button>
      </div>
    }

    <div id="dependencies-table-section" class="table-container">
      @if (loading$ | async) {
        <div class="loading-container">
          <mat-spinner diameter="50"></mat-spinner>
          <p>{{ labels.loadingDependencies }}</p>
        </div>
      } @else if (error$ | async) {
        <div class="error-container">
          <p class="error-message">{{ error$ | async }}</p>
          <button mat-raised-button color="primary" (click)="loadDependencies()">Retry</button>
        </div>
      } @else {
        @if (dataSource.data.length > 0) {
          <div class="table-wrapper">
            <table
              id="dependencies-table"
              mat-table
              [dataSource]="dataSource"
              class="mat-elevation-z8 full-width-table styled-table"
              matSort
            >
              <!-- ID Column -->
              <ng-container matColumnDef="id">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableId }}</th>
                <td mat-cell *matCellDef="let element">{{ element.dependenciaId }}</td>
              </ng-container>

              <!-- Detail Column -->
              <ng-container matColumnDef="detail">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableDetail }}</th>
                <td mat-cell *matCellDef="let element">{{ element.detalle }}</td>
              </ng-container>

              <!-- Code Column -->
              <ng-container matColumnDef="code">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableCode }}</th>
                <td mat-cell *matCellDef="let element">{{ element.codigo }}</td>
              </ng-container>

              <!-- Status Column -->
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableStatus }}</th>
                <td mat-cell *matCellDef="let element">
                  <span [class]="element.isDisponible ? 'status-active' : 'status-inactive'">
                    {{ element.isDisponible ? 'Activo' : 'Inactivo' }}
                  </span>
                </td>
              </ng-container>

              <!-- Parent Column -->
              <ng-container matColumnDef="parent">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableParent }}</th>
                <td mat-cell *matCellDef="let element">
                  {{ getParentName(element.padreId, (displayDependencies$ | async) ?? []) }}
                </td>
              </ng-container>

              <!-- Actions Column -->
              <ng-container matColumnDef="actions">
                <th mat-header-cell *matHeaderCellDef>{{ labels.tableActions }}</th>
                <td mat-cell *matCellDef="let element">
                  <div class="action-buttons">
                    <button
                      mat-icon-button
                      class="view-button"
                      matTooltip="{{ labels.tooltipView }}"
                      (click)="viewDetail(element, false)"
                    >
                      <mat-icon>visibility</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="edit-button"
                      matTooltip="{{ labels.tooltipEdit }}"
                      (click)="openModal(element)"
                    >
                      <mat-icon>edit</mat-icon>
                    </button>
                    <button
                      mat-icon-button
                      class="toggle-button"
                      [matTooltip]="element.isDisponible ? 'Desactivar' : 'Activar'"
                      (click)="toggleDependencyStatus(element)"
                    >
                      <mat-icon>{{ element.isDisponible ? 'toggle_on' : 'toggle_off' }}</mat-icon>
                    </button>
                    <!-- Botón de eliminar comentado temporalmente
                  <button
                    mat-icon-button
                    class="delete-button"
                    matTooltip="Eliminar"
                    (click)="deleteDependency(element)"
                  >
                    <mat-icon>delete</mat-icon>
                  </button>
                  --></div>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: tableColumns" class="dependency-row"></tr>
            </table>

            <!-- Paginador -->
            <mat-paginator
              #paginator
              [pageSize]="pageSize"
              [pageSizeOptions]="pageSizeOptions"
              [showFirstLastButtons]="true"
              (page)="onPageChange()"
              aria-label="Seleccionar página de dependencias"
            >
            </mat-paginator>
          </div>
        } @else {
          <div class="no-data-container">
            <mat-icon class="no-data-icon">inbox</mat-icon>
            <p>{{ labels.noDependencies }}</p>
            <button mat-raised-button color="primary" (click)="openModal()">
              {{ labels.createDependency }}
            </button>
          </div>
        }
      }
    </div>
  </mat-card>
</div>

<ng-template #createDependencyModal>
  <h2 id="dependency-modal-title" mat-dialog-title>
    {{ isEditing ? labels.editDependency : labels.createDependency }}
  </h2>

  <mat-dialog-content id="dependency-modal-content" class="modal-content">
    <form id="dependency-form" [formGroup]="dependencyForm">
      <!-- ID Field (solo para edición) -->
      @if (isEditing && editingDependency) {
        <mat-form-field appearance="outline" class="full-width">
          <mat-label>{{ labels.dependencyId }}</mat-label>
          <input matInput [value]="editingDependency.dependenciaId" readonly />
          <mat-icon matSuffix>lock</mat-icon>
        </mat-form-field>
      }

      <!-- Detail Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.detail }}</mat-label>
        <input
          matInput
          formControlName="detalle"
          placeholder="Ingrese el detalle de la dependencia"
          [class.error-field]="hasError('detalle')"
        />
        @if (hasError('detalle')) {
          <mat-error>{{ getErrorMessage('detalle') }}</mat-error>
        }
      </mat-form-field>

      <!-- Code Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.code }}</mat-label>
        <input
          matInput
          formControlName="codigo"
          placeholder="Ingrese el código"
          [class.error-field]="hasError('codigo')"
          (blur)="onCodeBlur()"
        />
        @if (hasError('codigo')) {
          <mat-error>{{ getErrorMessage('codigo') }}</mat-error>
        }
      </mat-form-field>

      <!-- Parent Dependency Field -->
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>{{ labels.selectParent }}</mat-label>
        <mat-select formControlName="padreId">
          <mat-option [value]="null">{{ labels.notSelected }}</mat-option>
          @for (
            dependency of parentDependencies$ | async;
            track trackByDependencyId(dependency.dependenciaId, dependency)
          ) {
            @if (!isEditing || dependency.dependenciaId !== editingDependency?.dependenciaId) {
              <mat-option [value]="dependency.dependenciaId">
                {{ dependency.detalle }} ({{ dependency.codigo }})
              </mat-option>
            }
          }
        </mat-select>
      </mat-form-field>

      <!-- Status Field -->
      <div class="status-field">
        <mat-slide-toggle formControlName="isDisponible" color="primary">
          {{ labels.isAvailable }}
        </mat-slide-toggle>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions id="dependency-modal-actions" align="end">
    <button
      id="save-dependency-button"
      mat-button
      mat-raised-button
      color="primary"
      (click)="saveDependency()"
      [disabled]="dependencyForm.invalid"
    >
      <mat-icon>save</mat-icon>
      {{ labels.save }}
    </button>
    <button id="cancel-dependency-button" mat-button (click)="closeModal()">
      {{ labels.cancel }}
    </button>
  </mat-dialog-actions>
</ng-template>

<ng-template #detailModal>
  <div class="detail-modal-container">
    <!-- Header -->
    <div class="detail-modal-header">
      <h2 id="detail-modal-title" mat-dialog-title>Detalle de Dependencia</h2>
    </div>

    <!-- Content -->
    <mat-dialog-content id="detail-modal-content" class="detail-modal-content">
      <div class="detail-info">
        <div class="detail-row">
          <span class="detail-label">ID:</span>
          <span class="detail-value">{{ detailBeingViewed?.dependenciaId }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Detalle:</span>
          <span class="detail-value">{{ detailBeingViewed?.detalle }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Código:</span>
          <span class="detail-value code-value">{{ detailBeingViewed?.codigo }}</span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Estado:</span>
          <span class="detail-value">
            <span
              class="status-badge"
              [class]="detailBeingViewed?.isDisponible ? 'status-active' : 'status-inactive'"
            >
              {{ detailBeingViewed?.isDisponible ? 'Activo' : 'Inactivo' }}
            </span>
          </span>
        </div>

        <div class="detail-row">
          <span class="detail-label">Dependencia Padre:</span>
          <span class="detail-value">{{
            getParentName(detailBeingViewed?.padreId, (dependencies$ | async) ?? [])
          }}</span>
        </div>
      </div>
    </mat-dialog-content>

    <!-- Actions -->
    <mat-dialog-actions id="detail-modal-actions" align="end" class="detail-modal-actions">
      <button id="close-detail-button" mat-button mat-dialog-close class="close-detail-button">
        {{ labels.close }}
      </button>
    </mat-dialog-actions>
  </div>
</ng-template>
